import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import {
  setLocation,
  setNavigatedOnClient,
} from '../actions/location';

const initialState = {
  basename: null,
  baseURL: null,
  entryPath: null
};

export default handleActions({
  [setLocation]: (state, { payload }) => payload,
  [setNavigatedOnClient]: state => ({
    ...state,
    navigatedOnClient: true,
  })
}, initialState);



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/location.js